import styles from './Spinner.module.scss';

interface Props {
  size?: string;
}

export const Spinner = ({ size }: Props) => (
  <div className={styles.spinWrapper} style={{ height: size || '100vh' }}>
    <div className={styles.spinner}> </div>
  </div>
);
